<template>
  <el-dialog
    :visible="visible"
    width="40%"
    @close="cancel"
    destroy-on-close
    title="物流信息"
    custom-class="customModal">
    <div class="logistics">
        <div class="layer">
            <div class="title">物流信息</div>
            <div class="ship_title">{{shipData.shipping_name}}:{{shipData.nu}}</div>
        </div>
        <div class="layer step">
            <div class="title mt30">物流状态：{{orderState.get(+shipData.state)}}</div>
            <div class="detail">
                <div class="right" v-for="(item,index) in shipData.data" :key="index">
                    <div class="time">{{ item.time}}</div>
                    <div class="information">
                        【{{item.status}}】&emsp; {{ item.context }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    </el-dialog>
</template>

<script>
import { OrderService } from '../../service/order.service';

const orderState = new Map([
    [0, '在途'],
    [1, '揽收'],
    [2, '疑难'],
    [3, '签收'],
    [4, '退签'],
    [5, '派件'],
    [6, '退回'],
    [7, '转单'],
    [10, '待清关'],
    [11, '清关中'],
    [12, '已清关'],
    [13, '清关异常'],
    [14, '收件人拒签'],
]);
export default {
    name: 'queryLogistics',
    data() {
        return {
            orderState,
            shipData: {
                data: [],
            },
            orderData: {},
            visible: false,
        }
    },
    async created() {
      },
    methods: {
      async open(data) {
        this.shipData = await OrderService.queryShipping(data.order_sn);
        this.shipData.state = +this.shipData.state;
        this.shipData.data.map(item => {
            item.date = item.time.split(' ')[0];
            item.today = item.time.split(' ')[1];
        });
        this.visible = true;
        this.orderData = data;
      },
      cancel() {
        this.visible = false;
      },
    }
}
</script>

<style lang="scss" scoped>

    .ship_title {
        font-size: 16px;
        padding: 16px;
    }
    .title{
        font-size: 15px;
        font-weight: 700;
        text-indent: 2em;
        border-bottom: 1px solid #e3e2e1;
        padding-bottom: 8px;
    }
    .detail{
        line-height: 40px;
        .right{
            display: flex;
            border-bottom: 1px solid #eee;
            .information{
                margin-left: 30px;
                text-align: left;

            }
        }
    }
    .time {
      white-space: nowrap;
      font-weight: bold;
    }
</style>